import React from "react";
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { testAttributes } from './Constants';
import { imageContainer, blockImage } from './FeaturedImage.module.scss';

const FeaturedImage = ({
    gatsbyFeaturedImage = null,
    imgPath = '',
    testId = testAttributes.FEATURED_IMAGE_SOURCE,
    imgAlt = ''
}) =>
{
    const featuredImageComp = () =>
    {
        if (gatsbyFeaturedImage)
        {
            return <GatsbyImage
                image={
                    gatsbyFeaturedImage
                }
                className={blockImage}
                alt={imgAlt}
                itemProp="image"
                data-testid={testId}
            />
        }

        if (imgPath)
        {
            return <img
                src={imgPath}
                className={blockImage}
                alt={imgAlt}
                itemProp="image"
                data-testid={testId}
                loading="lazy"
            />
        }
        return null;
    };

    return (
        <div
            className={`${imageContainer} customFeaturedImageCss`}
            data-testid={testAttributes.FEATURED_IMAGE_CONTAINER}
        >
            {featuredImageComp()}
        </div>
    )
};

FeaturedImage.propTypes = {
    /** alt of the image */
    imgAlt: PropTypes.string,
    /** Image; Set URL for any image */
    gatsbyFeaturedImage: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node,
        PropTypes.object,
    ]),
    /** Image path to render regular DOM img tag */
    imgPath: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object,
        PropTypes.string
    ]),
    /** testId Custom data-testid attribute */
    testId: PropTypes.string,
}

export default FeaturedImage;